export class PMOConvertTaskToProjectModel {
    constructor() {
        this.isMainProject = true;
        this.projectOwnerId = "";
    }
}
export default class PMOProject extends PMOConvertTaskToProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
